// extracted by mini-css-extract-plugin
export var button = "_mx-0";
export var donut = "_mx-1";
export var donutFill = "_mx-3";
export var donutTrack = "_mx-2";